<template>
  <CHeader position="fixed" :class="`mb-4 bg-theme-primary theme-rounded-topbar border-0 ${$route.name == 'Dashboard' ? '' : 'shadow'}`">
    <CContainer fluid>
      <CHeaderToggler class="topbar-sidebar-toggle bg-theme-white text-center text-dark p-2" @click="$store.commit('toggleSidebar')">
        <CIcon icon="cil-list" size="xl" />
      </CHeaderToggler>
      <CHeaderBrand class="mx-auto d-lg-none" to="/">
        <CImage
          class="sidebar-brand-full small-size-logo"
          :src="LongLogo"
          :height="50"
        />
      </CHeaderBrand>
      <!-- <CHeaderNav class="d-none d-md-flex me-auto">
        <CNavItem>
          <CNavLink href="/dashboard"> Dashboard </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#">Users</CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#">Settings</CNavLink>
        </CNavItem>
      </CHeaderNav> -->
      <CHeaderNav class="align-items-center">
        <AppHeaderDropdownNotif class="d-none d-lg-block" />
        <AppHeaderDropdownAccnt />
      </CHeaderNav>
    </CContainer>
    <!-- <CHeaderDivider /> -->
    <!-- <CContainer fluid>
      <AppBreadcrumb />
    </CContainer> -->
  </CHeader>
</template>

<script>
// import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import AppHeaderDropdownNotif from './AppHeaderDropdownNotif'
import Logos from '@/assets/brand/index'
export default {
  name: 'AppHeader',
  components: {
    // AppBreadcrumb,
    AppHeaderDropdownAccnt,
    AppHeaderDropdownNotif,
  },
  setup() {
    return {
      LongLogo: Logos.LongT4TPNG,
    }
  }
}
</script>
